'use strict';

import BATCH_STATUSES from '../../models/batchStatuses';

const POLLING_TIME = 15000;
const BATCH_STATUS_RETRIEVED = 'batchStatusRetrieved';

class StatusIndicatorService {
  constructor(config, $http, httpDim, $rootScope) {
    this.$http = $http;
    this.config = config;
    this.httpDim = httpDim;
    this.$rootScope = $rootScope;
    this.statusPoll = 0;
    this.listenForImpersonate();
  }

  getStatus() {
    let url = this.config.apiRoot + '/batches/last';
    var config = this.config;

    url = this.httpDim.appendCacheBust(url);

    return this.$http.get(url, config);
  }

  listenForImpersonate() {
    this.$rootScope.$on('impersonate', this.retrieveStatus.bind(this));
  }

  pollForStatus() {
    this.statusPoll = setInterval(this.retrieveStatus.bind(this), POLLING_TIME);
  }

  retrieveStatus() {
    this.getStatus().then(
      this.onLastBatchStatusRetrievalSuccess.bind(this),
      this.onLastBatchStatusRetrievalFailure.bind(this)
    );
  }

  onLastBatchStatusRetrievalSuccess(response) {
    let batch = response.data.content || { status: 'NOT_AVAILABLE' };
    this.setBatchStatus(batch);
    this.$rootScope.$emit('batchStatusRetrieved', batch);
  }

  setBatchStatus(batch) {
    let upperCaseStatus = batch.workflowStatus || '';
    if(batch.debugInfo === 'zip file is incomplete') {
      this.batchStatus = BATCH_STATUSES.INVALID;
    } else {
      upperCaseStatus = upperCaseStatus.toUpperCase();
      this.batchStatus = BATCH_STATUSES[upperCaseStatus];
    }
  }

  onLastBatchStatusRetrievalFailure() {
    this.batchStatus = BATCH_STATUSES.STATUS_INDICATOR_FAIL;
    clearInterval(this.statusPoll);
  }

  isInProcess() {
    return (this.batchStatus === BATCH_STATUSES['IN PROCESS'] || this.batchStatus === BATCH_STATUSES['IN_PROGRESS']);
  }

  batchHasFinished() {
    return (this.batchStatus === BATCH_STATUSES.COMPLETE || this.batchStatus === BATCH_STATUSES.NOT_AVAILABLE || this.batchStatus === BATCH_STATUSES.FAILED || this.batchStatus === BATCH_STATUSES.CANCELLED);
  }

  getBatchStatusEventName() {
    return BATCH_STATUS_RETRIEVED;
  }
}

StatusIndicatorService.$inject = ['config', '$http','httpDim', '$rootScope'];

export
default StatusIndicatorService;



// WEBPACK FOOTER //
// ./app/components/statusIndicator/statusIndicator.service.js